import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import { Paper } from '@material-ui/core';

class ForecastGraphComponent extends Component {
  render() {
    const line1Data = [65, 59, 80, 81, 56, 55, 65, 59, 80, 80];
    const line2Data = [55, 49, 70, 75, 45, 42, 50, 55, 70, 71];
    const continuation1Data = [80, 76, 55, 65, 59, 80, 81, 56, 55, 65];
    const continuation2Data = [71, 65, 42, 50, 55, 70, 75, 55, 49, 60];

    const data = {
      labels: [ '11:00', '11:05', '11:10', '11:15', '11:20', '11:25', '11:30', '11:35', '11:40', '11:45', '11:50', '11:55', '12:00', '12:05', '12:10', '12:15', '12:20', '12:25', '12:30', '12:35', ],
      datasets: [
        {
          label: 'Actural Irradiance',
          data: line1Data,
          fill: true,
          borderColor: 'rgb(140,32,45)',
          backgroundColor: 'rgba(140,32,45, 0.2)',
        },
        {
          label: 'Actural Active Power',
          data: line2Data,
          fill: true,
          borderColor: 'rgb(239,131,57)',
          backgroundColor: 'rgba(239,131,57, 0.2)',
        },
        {
          label: 'Forecasted Irradiance',
          data: [null, null, null, null, null, null, null, null, null, ...continuation1Data],
          fill: true,
          borderColor: 'rgb(151,54,66)',
          backgroundColor: 'rgba(151,54,66, 0.2)',
          borderDash: [5, 5], 
        },
        {
          label: 'Forecasted Active Power',
          data: [null, null, null, null, null, null, null, null, null, ...continuation2Data],
          fill: true,
          borderColor: 'rgb(240,143,76)',
          backgroundColor: 'rgba(240,143,76, 0.2)',
          borderDash: [5, 5], 
        },
      ],
    };
    const options = {
        animation: {
          easing: 'easeInOutQuad',
        },
        scales: {
            yAxes: [
              {

                scaleLabel: {
                  display: true,
                  labelString: 'kWhr',
                },
              },
            ],
            xAxes: [
                {
      
                  scaleLabel: {
                    display: true,
                    labelString: 'Time',
                  },
                },
              ],
          },
        };

    return (
        <Line data={data} options={options} />
    );
  }
}

export default ForecastGraphComponent;
